export function formatStripePriceWithCurrency(currencyISOCode: string, stripeAmount: number) {
    // USA local same as other English, but shows just $ instead of US$, and AUD will show A$
    let locale = 'en-us';
    if (currencyISOCode.toUpperCase() === 'ZAR') {
        locale = 'en-ZA'; // other locales don't show R in front
    }

    //  This method only support only 2 decimal currencies (majority), which Stripe times by 100
    //  https://docs.stripe.com/currencies#zero-decimal
    //  https://stackoverflow.com/questions/65893967/
    //  what-is-the-best-way-to-display-currency-amounts-smallest-units-from-any-curren
    const unsupportedCurrencies =
      ['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF',
      'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF', 'BHD', 'JOD', 'KWD', 'OMR', 'TND',
      'BHD', 'JOD', 'KWD', 'OMR', 'TND',
      ];
    if (unsupportedCurrencies.find((unsupported) => unsupported === currencyISOCode.toUpperCase()) != null) {
      throw new Error(`Currency ${currencyISOCode} unsupported by formatter`);
    }
    const stripeMultiplier = 100;
    const amount = stripeAmount / stripeMultiplier;

    const formatted = new Intl.NumberFormat(locale, { style: 'currency', currency: currencyISOCode }).format(amount);
    return formatted;
  }
